import styled from "styled-components/native"

export const Container = styled.View`
    display: flex;
    flex-direction: column;
    height: 100%;
`